import { render, staticRenderFns } from "./Preembarques.vue?vue&type=template&id=120c949c&scoped=true&"
import script from "./Preembarques.vue?vue&type=script&lang=js&"
export * from "./Preembarques.vue?vue&type=script&lang=js&"
import style0 from "./Preembarques.vue?vue&type=style&index=0&id=120c949c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120c949c",
  null
  
)

export default component.exports